import { createSelector } from 'reselect';
import { getResources } from '@flowio/redux-resource';

export const getCurrencyResourceSlice = (state) => state.resources.currencies;

export const getCurrencies = createSelector(
  getCurrencyResourceSlice,
  (resourceSlice) => getResources(resourceSlice),
);
